import CloseIcon from "../images/icons/close.inline.svg"
import Modal from "react-modal"
import React from 'react';
Modal.setAppElement("#___gatsby")

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.58)",
    zIndex: "999",
  },
  content: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    maxWidth: "737px",
    margin: "50px auto",
    padding: 0,
    border: 0,
    overflowY: "auto",
    borderRadius: "8px",
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, .25)",
    height: "max-content",
    maxHeight: "85vh",
    background: "rgb(120, 84, 224)"
  },
}


export const ContactUsModal = ({showModal, setShowModal, headline, btnText, subject}) => {
  const postForm = function() {
    window.open(
      `https://meetings.hubspot.com/fullstack/demo-session-with-growth-full-stack`,
      '_blank',
      'noopener'
    );
    setShowModal(false)
  }

  return (
    <Modal style={modalStyles} isOpen={showModal}>
      <button
        className="absolute focus:outline-none mr-4 md:mr-8 lg:mr-10 mt-5 lg:mt-10 outline-none right-0 top-0"
        onClick={() => setShowModal(false)}
      >
        <CloseIcon className="fill-current text-white" />
      </button>
      <div className="bg-primary px-4 md:px-8 lg:px-24 pt-10 lg:pt-20 pb-10 lg:pb-22 rounded-lg w-full flex flex-col space-y-6 max-h-fit-content">
        <h2 className="font-black text-3xl lg:text-5xl text-white">{subject}</h2>
        <p className="text-white" dangerouslySetInnerHTML={{__html: headline}}></p>
        <form className="flex flex-col space-y-4">
          <button type="button" className="bg-black font-bold py-4 rounded text-white text-lg lg:text-xl" onClick={() => postForm()}>
            {btnText}
          </button>
        </form>
      </div>
    </Modal>
  )
}
